import { LoginServe } from "@/service";
import { defineStore } from "pinia";
import { Desensitization } from "@dg/utils";

export const useUserStore = defineStore("user", {
  state: () => ({
    userInfo: null,
    userStatus: null,
  }),
  actions: {
    async getUserInfo() {
      let { success, data } = await LoginServe.getUserInfo();
      if (success) {
        data.real_name = Desensitization.cnName(data.real_name).target;
        this.userInfo = data;
        const { success: typeSuccess, data: typeData } =
          await LoginServe.getUserType();
        if (typeSuccess) {
          const { user_type } = typeData;
          this.userInfo.userType = user_type;
        }
        if (this.userStatus === null) {
          const { success: statusSuccess, data: statusData } =
            await LoginServe.getUserStatus();
          if (statusSuccess) {
            this.setStatus(statusData.initial);
          }
        }
      }
      return data;
    },
    clearUserInfo() {
      this.userInfo = null;
    },
    setStatus(val) {
      this.userStatus = val;
    },
  },
});
